import { api } from '@/lib/api-client.ts'

import { NewIssueSchemaT } from '@/routes/projectStages/issues/lib/schamas.ts'

export type FilterT = {
  name: string
  queryString: string
  issueType: string
}

export async function addCustomIssueFilter(data: FilterT) {
  return api.post(`/custom_issue_filters`, data)
}

export async function deleteCustomIssueFilter(id: string) {
  return api.delete(`${id}`)
}

export async function deleteIssue(id: string | null) {
  // ONLY FOR DRAFT ISSUES!
  return api.delete(`/issues/${id}`)
}

export async function editIssue(id: string | null, data: NewIssueSchemaT) {
  // ONLY FOR DRAFT ISSUES!
  return api.patch(`/issues/${id}`, data)
}
